import {
  FacebookShareButton,
  TwitterShareButton,
  PinterestShareButton,
  TumblrShareButton,
  EmailShareButton,
} from 'react-share'

export const listShare = ({ title = '', img = '', desc = '' }) => [
  {
    'Component': FacebookShareButton,
    'quote': title,
    'data-tippy-content': 'Facebook',
    'ico': 'fb',
  },
  {
    'Component': TwitterShareButton,
    'title': title,
    'data-tippy-content': 'Twitter',
    'ico': 'tw',
  },

  {
    'Component': PinterestShareButton,
    'media': img,
    'windowWidth': 1000,
    'windowHeight': 730,
    'data-tippy-content': 'Pinterest',
    'ico': 'pi',
  },
  {
    'Component': TumblrShareButton,
    'title': title,
    'windowWidth': 660,
    'windowHeight': 460,
    'data-tippy-content': 'Tumblr',
    'ico': 'tu',
  },
  {
    Component: EmailShareButton,
    subject: title,
    body: desc,
    content: 'Send to email',
    ico: 'em',
  },
]

export const styleShare = {
  cursor: 'pointer',
  width: '100%',
  height: '100%',
  position: 'absolute',
  top: 0,
  left: 0,
}

export const styleDropdownItem = {
  position: 'relative',
}

export const styleCursor = {
  cursor: 'pointer',
}
